import React from 'react'

export function useContinuousRef<T>(current: T): React.MutableRefObject<T> {
  const ref = React.useRef<T>(current)
  ref.current = current
  return ref
}